import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import CheckboxWithoutForm from '@atoms/CheckboxWithoutForm';
import SportsWaiverModal from '@modals/SportsWaiverModal';
import { LinkSmall } from '@react/styledComponents';

const ComponentContainerStyled = styled.div`
    margin-left: 28px;
`;

const TextStyled = styled(LinkSmall)`
    color: black !important;
    cursor: default;
    display: block;
`;

const SportsWaiver = ({ checked, disabled, onCheckChange }) => {
    const [sportsWaiverModalOpen, setSportsWaiverModalOpen] = useState(false);

    return (
        <ComponentContainerStyled>
            <CheckboxWithoutForm checked={checked} disabled={disabled} onCheckChange={onCheckChange}>
                <span>
                    <TextStyled as="span" className="inline">
                        I've read and agree to the{' '}
                    </TextStyled>

                    <LinkSmall
                        onClick={e => {
                            e.preventDefault();
                            setSportsWaiverModalOpen(true);
                        }}
                    >
                        Sports Waiver
                    </LinkSmall>
                </span>
            </CheckboxWithoutForm>

            <SportsWaiverModal isOpen={sportsWaiverModalOpen} onClose={() => setSportsWaiverModalOpen(false)} />
        </ComponentContainerStyled>
    );
};

SportsWaiver.propTypes = {
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    onCheckChange: PropTypes.func.isRequired,
};

export default SportsWaiver;
